export * from "./cognito";
export const CHALLANGE_TEXT = "zcode";
export const API =
  process.env.REACT_APP_API_BASE_URL ||
  "https://afc9n41cb5.execute-api.ap-southeast-1.amazonaws.com/dev";
export const DEV_USER_ID = process.env.REACT_APP_DEV_USER_ID || "";
